import { Block, HeadingSmall, ParagraphSmall, useStyletron, } from "@mezo-org/mezo-clay";
import React from "react";
export default function AccountBalance(props) {
    const { amount } = props;
    const [, theme] = useStyletron();
    return (React.createElement(Block, { padding: theme.sizing.scale500, overrides: {
            Block: {
                style: {
                    borderBottom: `1px solid ${theme.colors.backgroundPrimary}`,
                },
            },
        } },
        React.createElement(ParagraphSmall, { margin: 0, color: theme.colors.gray800 }, "Available balance"),
        React.createElement(HeadingSmall, { margin: 0 }, amount)));
}
//# sourceMappingURL=AccountBalance.js.map